import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { formatQueryParams } from "helpers/format";
import adultVerifyLogApi from "api/adultVerifyLogApi";

export const getAdultVerifyLogs = createAsyncThunk(
  "AdultVerifyLogs",
  async (params: any = {}) => {
    try {
      const response = await adultVerifyLogApi.adultVerifyLogs(formatQueryParams(params));
      return response;
    } catch (error) {
      return error;
    }
  }
);

